export enum TezinaPitanja {
	LAKO = 1,
	SREDNJE = 2,
	TESKO = 3,
	NAPREDNO = 4,
}
